import { render, staticRenderFns } from "./TramitacionesInstalacion.vue?vue&type=template&id=c1790190&"
import script from "./TramitacionesInstalacion.vue?vue&type=script&lang=js&"
export * from "./TramitacionesInstalacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports